module.exports = __webpack_public_path__ + "static/media/PLANTA.43491650.jpg";